import * as React from 'react';

// ICONS
import { ReactComponent as SearchIcon } from '../assets/svg/search.svg';

// TYPES
import { StaffDashboardStaffMember } from '../api/models/staff-dashboard-staff-member';

interface SearchInputTypes {
	searchPlaceholder: string;
	originalStaffData: StaffDashboardStaffMember[];
	setStaffData: React.Dispatch<React.SetStateAction<StaffDashboardStaffMember[]>>;
}

const SearchInput: React.FC<SearchInputTypes> = ({ searchPlaceholder, originalStaffData, setStaffData }) => {
	const [searchValue, setSearchValue] = React.useState<string>('');

	const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newSearchValue = e.target.value;

		if (!newSearchValue) {
			setStaffData(originalStaffData);
		} else {
			const newStaffData = originalStaffData.filter(
				(data) =>
					(data.firstName && data.firstName.toLowerCase().includes(newSearchValue.toLowerCase())) ||
					(data.lastName && data.lastName.toLowerCase().includes(newSearchValue.toLowerCase()))
			);

			setStaffData(newStaffData);
		}

		setSearchValue(newSearchValue);
	};

	return (
		<div className="seach-container">
			<SearchIcon />
			
			<input onChange={onChangeHandler} type="text" placeholder={searchPlaceholder} value={searchValue} />
		</div>
	);
};

export default SearchInput;
